module.exports = __webpack_public_path__ + "static/media/bg-session-conlicitacao-register.8ab1b6e2.png";